import { CSSProperties } from 'react';
import { useDevtoolStore } from '../../store/devtoolSlice';
import { usePerfStatsStore } from '../../store/perfStatsSlice';

const OVERLAY_STYLE: CSSProperties = {
  position: 'fixed',
  top: 8,
  right: 8,
  zIndex: 9999,
  pointerEvents: 'none',
  padding: '4px 8px',
  background: 'rgba(0, 0, 0, 0.6)',
  color: '#7CFC9B',
  font: '11px/1.4 monospace',
  whiteSpace: 'pre',
  borderRadius: 4,
};

export const RendererStatsOverlay = () => {
  const devMode = useDevtoolStore((s) => s.devModeEnabled);
  const stats = usePerfStatsStore((s) => s.stats);
  if (!devMode || !stats) {
    return null;
  }
  return (
    <div style={OVERLAY_STYLE}>
      {`draws/frame ${stats.drawsPerFrame.toFixed(1)}\n` +
        `sprites    ${stats.sprites}\n` +
        `baseTex    ${stats.baseTextures}`}
    </div>
  );
};
